import { render, staticRenderFns } from "./translation-memory.vue?vue&type=template&id=891e19ae&"
import script from "./translation-memory.vue?vue&type=script&lang=js&"
export * from "./translation-memory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cristi\\Documents\\Work\\www\\tpdemo\\wp-content\\plugins\\translatepress\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('891e19ae', component.options)
    } else {
      api.reload('891e19ae', component.options)
    }
    module.hot.accept("./translation-memory.vue?vue&type=template&id=891e19ae&", function () {
      api.rerender('891e19ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/src/js/components/translation-memory.vue"
export default component.exports